export default __webpack_public_path__ + "static/media/orchid_tracking-black.5a169d78.svg";